<template>
  <div
    class="canvas"
    @mousemove="handleMouseMove"
    @touchmove="handleTouchMove"
    :class="{
      open: Open,
      error: SetEsError(
        aplicacion.coleccionSel.sideSel.Live.EsError(
          aplicacion.coleccionSel.sideSel.Live.perfil
        )
      ),
      loading: Loading,
      zoom: Zoom,
    }"
  >
    <img
      crossOrigin="anonymous"
      src="@/assets/Images/Global/Loader.svg"
      alt=""
      class="canvas__loader"
    />
    <div class="canvas__error">
      <img
        crossOrigin="anonymous"
        src="@/assets/Images/Global/Error.svg"
        alt=""
        class="canvas__error__image"
      />
      <div class="canvas__error__textos">
        <p class="canvas__error__textos__item">Selección incompatible.</p>
        <p class="canvas__error__textos__item">
          Por favor, elija una opción válida.
        </p>
      </div>
    </div>
    <img
      crossOrigin="anonymous"
      v-for="(Grupo, GrupoIndex) in aplicacion.coleccionSel.sideSel.Live.grupos"
      :key="GrupoIndex"
      src="@/assets/Images/Global/Hotspot.svg"
      :id="Grupo.cod"
      alt=""
      class="canvas__hotspot"
      :class="{
        active: Grupo.cod == aplicacion.grupoSel.Live.cod,
        hidden:
          !Hotspots || SetAdicionales(Grupo) || Grupo.position.hotSpot == false,
      }"
      @click="SetGrupo(Grupo)"
      :style="
        'left: ' +
        Grupo.position['left'] +
        '; top: ' +
        Grupo.position['top'] +
        ';'
      "
    />
    <div
      class="canvas__comparator"
      :class="{
        hidden: !Comparador,
      }"
      :style="
        Version == '4000'
          ? 'right:calc(' + Exposure + ' - 25px);'
          : 'right:calc(' + Exposure + ' - 20px);'
      "
    >
      <img
        crossOrigin="anonymous"
        @click="SetSide(Side)"
        v-for="(Side, SideIndex) in aplicacion.coleccionSel.sides"
        :key="SideIndex"
        src="@/assets/Images/Global/Side.png"
        alt=""
        class="canvas__comparator__side"
        :class="{
          active: aplicacion.coleccionSel.sideSel.Live == Side,
        }"
      />
    </div>
    <v-zoomer ref="zoomer" :zoomed.sync="zoomed" :limitTranslation="false">
      <img-comparison-slider
        @slide="SetExposure()"
        class="canvas__slider"
        :class="{
          hidden: !Comparador,
        }"
      >
        <canvas
          slot="first"
          class="canvas__slider__item"
          :style="Position"
          :width="Version == '1000' ? '1750px' : '4000px'"
          :height="Version == '1000' ? '1005px' : '2297px'"
        ></canvas>
        <canvas
          slot="second"
          class="canvas__slider__item"
          :style="Position"
          :width="Version == '1000' ? '1750px' : '4000px'"
          :height="Version == '1000' ? '1005px' : '2297px'"
        ></canvas>
      </img-comparison-slider>
    </v-zoomer>
  </div>
</template>

<script>
import VueZoomer from "vue-zoomer";

export default {
  name: "Canvas",
  components: {
    VZoomer: VueZoomer.Zoomer,
    VZoomerGallery: VueZoomer.Gallery,
  },
  props: {
    Version: String,
    Open: Boolean,
    Comparador: Boolean,
    Hotspots: Boolean,
    Zoom: Boolean,
    aplicacion: Object,
  },
  data() {
    return {
      zoomed: false,
      mouseX: 50,
      mouseY: 50,
      Loading: true,
      Canvas: Element,
      Context: Element,
      First: null,
      Exposure: String,
      separador: "&",
      separador2: "-",
      extension: "webp",
      Stored: {
        Comparador: false,
        Zoom: false,
      },
      Capas: { left: null, right: null },
    };
  },
  created() {
    //window.addEventListener("resize", this.Resize); // Salva
  },
  destroyed() {
    //window.removeEventListener("resize", this.Resize); // Salva
  },
  watch: {
    Comparador: {
      handler(newValue, oldValue) {
        this.SetComparador();
      },
      deep: true,
    },
    Version: {
      handler(newValue, oldValue) {
        this.Imagen(this.aplicacion, this.aplicacion.coleccionSel.sides[0]);
        this.Imagen(this.aplicacion, this.aplicacion.coleccionSel.sides[1]);
      },
      deep: true,
    },
    Zoom: {
      handler(newValue, oldValue) {
        this.zoomed = newValue;
        if (newValue) {
          this.$refs.zoomer.maxScale = 3;
          this.$refs.zoomer.zoomIn();
        } else {
          this.$refs.zoomer.reset();
          this.$refs.zoomer.zoomingElastic = false;
          this.$refs.zoomer.maxScale = 1;
          this.$refs.zoomer.minScale = 1;
        }
      },
      deep: true,
    },
  },
  computed: {
    canvasStyle() {
      const transformOrigin = `${this.mouseX}% ${this.mouseY}%`; // Punto de transformación

      return {
        transformOrigin: transformOrigin,
      };
    },
    Position() {
      var value;
      if (
        window.innerHeight < 650 ||
        (window.innerWidth < 950 && window.innerHeight > 650)
      ) {
        if (this.Open) {
          value = this.aplicacion.coleccionSel.objectPosition.open;
        } else {
          value = this.aplicacion.coleccionSel.objectPosition.close;
        }
      } else {
        value = "revert";
      }

      return { objectPosition: value + "!important" };
    },
  },
  mounted() {
    this.SetElements();
    this.SetDrawImages();
    this.aplicacion.coleccionSel.sides.forEach((side) => {
      this.Imagen(this.aplicacion, side);
    });
    this.$refs.zoomer.reset();
    this.$refs.zoomer.zoomingElastic = false;
    this.$refs.zoomer.maxScale = 1;
    this.$refs.zoomer.minScale = 1;
    setTimeout(() => {
      this.SetComparador();
    }, 350);
    //this.Resize(); // Salva
  },
  methods: {
    SetAdicionales(Grupo) {
      var status = false;
      status = Grupo.campos.every(
        (campo) =>
          campo.visible === false ||
          campo.Resolve(this.aplicacion.coleccionSel.sideSel.Live.perfil) ===
            false
      );
      if (status) {
        if (Grupo.cod == this.aplicacion.grupoSel.Live.cod) {
          this.SetGrupo(this.aplicacion.coleccionSel.sideSel.Live.grupos[0]);
        }
      }
      return status;
    },
    Resize() {
      // Salva
      function ResizeCanvas(canvas) {
        if (that.Version == "4000") {
          canvas.style.width = "";
          canvas.style.height = "";
          canvas.style.minHeight = "";
          canvas.style.maxHeight = "";

          var ratioImg = 4000 / 2297; //canvasRect.width / canvasRect.height;
          var ratioWindow = window.innerWidth / window.innerHeight;
          var offsetOpen = 0;
          if (that.Open) {
            offsetOpen = -350;
          }
          if (ratioWindow > ratioImg) {
            canvas.width = window.innerWidth;
            canvas.height = window.innerWidth / ratioImg;
            canvas.style.left = offsetOpen + "px";
            canvas.style.top =
              (-1 * (canvas.height / 2 - window.innerHeight / 2)).toString() +
              "px";
          } else {
            //console.log("ratioWindow <= ratioImg");
            canvas.height = window.innerHeight;
            canvas.width = window.innerHeight * ratioImg;
            canvas.style.top = "0px"; // Header
            canvas.style.left =
              (
                -1 * (canvas.width / 2 - window.innerWidth / 2) +
                offsetOpen
              ).toString() + "px";
          }

          that.Imagen(that.aplicacion, that.aplicacion.coleccionSel.sides[0]);
          that.Imagen(that.aplicacion, that.aplicacion.coleccionSel.sides[1]);
        } else {
          canvas.style.top = "";
          canvas.style.left = "";
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          canvas.style.minHeight = "calc(100dvh - $Header-height)";
          canvas.stylemaxHeight = "calc(100dvh - $Header-height)";
        }
      }
      var that = this;
      ResizeCanvas(this.Canvas["left"]);
      ResizeCanvas(this.Canvas["right"]);

      if (that.Version == "4000") {
        //console.log("----------------------------------------");
        var grupoHTML;
        var canvasTop, canvasHeight, position;
        this.aplicacion.coleccionSel.sideSel.Live.grupos.forEach((grupo) => {
          grupoHTML = document.getElementById(grupo.cod);

          canvasTop = parseInt(this.Canvas["left"].style.top.slice(0, -2));
          canvasHeight = this.Canvas["left"].height;
          position = parseInt(grupo.position.top.slice(0, -1)) / 100;

          grupoHTML.style.top =
            canvasTop + Math.floor(position * canvasHeight) + "px";
          canvasTop = parseInt(this.Canvas["left"].style.left.slice(0, -2));
          canvasHeight = this.Canvas["left"].width;
          position = parseInt(grupo.position.left.slice(0, -1)) / 100;
          grupoHTML.style.left =
            canvasTop + Math.floor(position * canvasHeight) + "px";
        });
      }
    },
    SetDrawImages() {
      this.$root.$on("DrawImages", (aplicacion, side) => {
        this.Imagen(aplicacion, side);
      });
    },
    handleMouseMove(event) {
      const containerRect = this.Canvas["left"].getBoundingClientRect();
      this.mouseX =
        ((event.clientX - containerRect.left) / containerRect.width) * 100;
      this.mouseY =
        ((event.clientY - containerRect.top) / containerRect.height) * 100;
    },
    handleTouchMove(event) {
      event.preventDefault();
      const containerRect = this.Canvas["left"].getBoundingClientRect();
      var touch = event.touches[0];
      var clientX = touch.clientX;
      var clientY = touch.clientY;

      // Calculate percentage based on container width and height
      this.mouseX =
        ((clientX - containerRect.left) / containerRect.width) * 100;
      this.mouseY =
        ((clientY - containerRect.top) / containerRect.height) * 100;

      // Determine maximum and minimum values
      const maxX = 100; // Maximum percentage value
      const maxY = 100; // Maximum percentage value
      const minX = 0; // Minimum percentage value
      const minY = 0; // Minimum percentage value

      // Ensure mouseX and mouseY stay within bounds
      this.mouseX = Math.max(minX, Math.min(maxX, this.mouseX));
      this.mouseY = Math.max(minY, Math.min(maxY, this.mouseY));
    },
    SetEsError(Status) {
      if (Status) {
        if (this.Comparador) {
          this.$emit("Comparador", false);
          this.Stored.Comparador = true;
        }
        if (this.Zoom) {
          var Zoom;
          if (window.location.href.includes("8081")) {
            Zoom = document.getElementsByClassName("buttons__item")[0];
          } else {
            Zoom = document
              .querySelector("c-selector")
              .shadowRoot.querySelector(".buttons__item");
          }
          this.Stored.Zoom = true;
          Zoom.click();
        }
      } else {
        if (this.Stored.Comparador) {
          this.$emit("Comparador", true);
          this.Stored.Comparador = false;
        }
        if (this.Stored.Zoom) {
          var Zoom;
          if (window.location.href.includes("8081")) {
            Zoom = document.getElementsByClassName("buttons__item")[0];
          } else {
            Zoom = document
              .querySelector("c-selector")
              .shadowRoot.querySelector(".buttons__item");
          }
          this.Stored.Zoom = false;
          Zoom.click();
        }
      }
      return Status;
    },
    SetGrupo(Grupo) {
      this.$emit("Grupo", Grupo);
    },
    SetExposure() {
      if (this.First != null) {
        this.Exposure = this.First.style.getPropertyValue("--exposure");
      }
    },
    SetSide(Side) {
      this.$emit("Side", Side);
    },
    SetComparador() {
      var Exposure;
      this.First.children[1].children[0].style.transition =
        "0.35s ease-in-out opacity";
      this.First.style.setProperty("--keyboard-transition-time", "0.35s");
      this.First.style.setProperty("--default-transition-time", "0.35s");
      if (this.Comparador) {
        this.First.children[1].children[0].style.opacity = 1;
        Exposure = "50%";
        this.First.style.setProperty("--exposure", Exposure);
        this.SetExposure();
      } else {
        if (this.aplicacion.coleccionSel.sideSel.Live.cod == "left") {
          Exposure = "0%";
        } else {
          Exposure = "100%";
        }
        setTimeout(() => {
          this.First.children[1].children[0].style.opacity = 0;
        }, 150);
        this.First.style.setProperty("--exposure", Exposure);
      }
      setTimeout(() => {
        this.First.style.setProperty("--keyboard-transition-time", "0s");
        this.First.style.setProperty("--default-transition-time", "0s");
      }, 150);
    },
    SetElements() {
      if (window.location.href.includes("8081")) {
        this.Canvas = {
          left: document.getElementsByClassName("canvas__slider__item")[0],
          right: document.getElementsByClassName("canvas__slider__item")[1],
        };
        this.First = document
          .getElementsByClassName("canvas__slider")[0]
          .shadowRoot.querySelector(".first");
      } else {
        this.Canvas = {
          left: document
            .querySelector("c-selector")
            .shadowRoot.querySelector(".canvas__slider")
            .querySelectorAll(".canvas__slider__item")[0],
          right: document
            .querySelector("c-selector")
            .shadowRoot.querySelector(".canvas__slider")
            .querySelectorAll(".canvas__slider__item")[1],
        };
        this.First = document
          .querySelector("c-selector")
          .shadowRoot.querySelector(".canvas__slider")
          .shadowRoot.querySelector(".first");
      }
      this.First.children[1].children[0].style.opacity = 0;
      this.Context = {
        left: this.Canvas.left.getContext("2d"),
        right: this.Canvas.right.getContext("2d"),
      };
    },
    TransformaAcabado(acabadoCod) {
      let cod;
      if (!isNaN(parseInt(acabadoCod))) {
        cod = acabadoCod.padStart(2, "0");
      } else {
        cod = acabadoCod;
      }
      return cod;
    },
    loadAsBlobImage(url) {
      return fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.blob();
        })
        .then((blob) => URL.createObjectURL(blob));
    },
    Imagen(aplicacion, side) {
      if (aplicacion.tipo == "estandar") {
        this.ImagenEstandar(aplicacion, side);
      } else {
        this.ImagenConfigurable(aplicacion, side);
      }
    },
    ImagenConfigurable(aplicacion, side) {
      var coleccion = aplicacion.colecciones[0];
      var archivo;
      var imagenes = new Set();

      var orden =
        coleccion.cod == "janeiro"
          ? {
              FONDO: 0,
              SUELO: 1,
              PARED: 2,
              POMO_ST_2: 3,
              COLOR_PERFIL_ST: 4,
              TIPO_VIDRIO: 5,
              DECORADO: 6,
              POMO_ST_1: 7,
            }
          : {
              FONDO: 0,
              SUELO: 1,
              PARED: 2,
              POMO_ST_2: 3,
              TIPO_VIDRIO: 4,
              ACRILICO: 5,
              DECORADO: 6,
              POMO_ST_1: 7,
              COLOR_PERFIL_ST: 8,
            };

      function NImagenes(coleccion, campo) {
        var ret = 1;
        if (campo == "POMO_ST") {
          ret = 2;
        }
        return ret;
      }

      var prefijo = "";
      if (coleccion.cod.toUpperCase() == "MINDANAO") {
        var campoOpciones = side.GetCampo("OPCIONES_MINDANAO");
        //console.log(campoOpciones);
        switch (campoOpciones.acabadoSel.cod) {
          case "00":
            prefijo = "_PERFILAPARED";
            break;
          case "01":
            prefijo = "_PERFILADAENMARCADA";
            break;
          case "02":
            prefijo = "_COZUMEL";
            break;
          case "03":
            prefijo = "_BARBADOS";
            break;
          case "04":
            prefijo = "_MARTINICA";
            break;
          default:
            break;
        }
      }

      let coleccionCod = coleccion.codImage;

      imagenes.add({
        orden: orden["FONDO"],
        archivo:
          coleccionCod + prefijo + this.separador + "FONDO." + this.extension,
        img: Image,
      });

      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          // //console.log(campo.cod, campo.esCapa, campo.visual,campo.GetLiteral("es"));
          if (side.ResolveCondicion(campo.condicion)) {
            if (campo.esCapa) {
              // Si el campo es compuesto la capa se forma con los códigos del campo y el campo compuesto
              if (campo.compuesto != undefined) {
                // HARDCODE 2: Imágenes dobles
                const nImagenes = NImagenes(coleccion.cod, campo.cod);
                // HARDCODE 2: Imágenes dobles
                const baseArchivo =
                  coleccion.codImage +
                  prefijo +
                  this.separador +
                  grupo.cod +
                  this.separador +
                  campo.cod +
                  this.separador2 +
                  campo.compuesto.cod +
                  this.separador +
                  this.TransformaAcabado(campo.acabadoSel.cod) +
                  this.separador2 +
                  campo.compuesto.acabadoSel.cod;

                if (nImagenes > 1) {
                  // Generar y agregar las imágenes
                  for (let i = 0; i < nImagenes; i++) {
                    archivo =
                      baseArchivo +
                      this.separador +
                      (nImagenes === 1 ? "" : i + 1) +
                      "." +
                      this.extension;
                    imagenes.add({
                      orden: orden[campo.cod + "_" + (i + 1)],
                      archivo: archivo,
                      img: Image,
                    });
                  }
                } else {
                  archivo = baseArchivo + "." + this.extension;
                  imagenes.add({
                    orden: orden[campo.cod],
                    archivo: archivo,
                    img: Image,
                  });
                }
              } else {
                if (campo.acabadoSel.compuesto == undefined) {
                  //archivo = campo.acabadoSel.capa;
                  // Es dinámico
                  archivo =
                    coleccion.codImage +
                    prefijo +
                    this.separador +
                    grupo.cod +
                    this.separador +
                    campo.cod +
                    this.separador +
                    campo.acabadoSel.cod +
                    "." +
                    this.extension;
                } else {
                  archivo =
                    coleccion.codImage +
                    prefijo +
                    this.separador +
                    grupo.cod +
                    this.separador +
                    campo.cod +
                    this.separador2 +
                    campo.acabadoSel.compuesto.cod +
                    this.separador +
                    campo.acabadoSel.cod +
                    this.separador2 +
                    campo.acabadoSel.compuesto.acabadoSel.cod +
                    "." +
                    this.extension;
                }
                imagenes.add({
                  orden: orden[campo.cod],
                  archivo: archivo,
                  img: Image,
                });
              }
            }
          }
        });
      });

      // Convertir a array
      imagenes = [...imagenes];

      imagenes = imagenes.sort(function (a, b) {
        return a.orden - b.orden;
      });

      var that = this;
      var imagenesPGN = [];
      Promise.all(
        imagenes.map((el) =>
          this.loadAsBlobImage(this.RequireImage(el.archivo)).then(
            (blobUrl) =>
              new Promise((resolve) => {
                const img = new Image();
                img.src = blobUrl;
                img.onload = () => {
                  el.img = img;
                  resolve(el);
                };
              })
          )
        )
      ).then((loadedImages) => {
        that.DibujaEscena(loadedImages, side);
      });
    },
    ImagenEstandar(aplicacion, side) {
      var coleccion = aplicacion.colecciones[0];
      var archivo;
      var imagenes = new Set();

      var orden = {
        FONDO: 0,
        SUELO: 1,
        PARED: 2,
        POMO_ST_2: 3,
        TIPO_VIDRIO: 4,
        DECORADO: 5,
        POMO_ST_1: 6,
        COLOR_PERFIL_ST: 7,
      };

      function NImagenes(coleccion, campo) {
        var ret = 1;
        if (campo == "tirador") {
          ret = 2;
        }
        return ret;
      }

      var prefijo = "";
      let coleccionCod = coleccion.codImage;

      if (coleccion.codImage == "MINDANAO") {
        prefijo = "_PERFILAPARED";
      }

      imagenes.add({
        orden: orden["FONDO"],
        archivo:
          coleccionCod + prefijo + this.separador + "FONDO." + this.extension,
        img: Image,
      });

      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          if (side.ResolveCondicion(campo.condicion)) {
            if (campo.esCapa) {
              let campoCod, campoCompuestoCod, acabadoCod, acabadoCompuestoCod;
              // Si el campo es compuesto la capa se forma con los códigos del campo y el campo compuesto
              if (campo.compuesto != undefined) {
                // HARDCODE 2: Imágenes dobles
                const nImagenes = NImagenes(coleccionCod, campo.cod);
                // HARDCODE 2: Imágenes dobles
                if (campo.cod == "tirador") {
                  campoCod = "POMO_ST";
                  campoCompuestoCod = "COLOR_PERFIL_ST";
                }

                acabadoCod = campo.acabadoSel.cod;
                acabadoCompuestoCod = campo.compuesto.acabadoSel.cod;
                if (!isNaN(parseInt(acabadoCod))) {
                  acabadoCod = acabadoCod.padStart(2, "0");
                }
                if (!isNaN(parseInt(acabadoCompuestoCod))) {
                  acabadoCompuestoCod = acabadoCompuestoCod.padStart(2, "0");
                }

                const baseArchivo =
                  coleccionCod +
                  prefijo +
                  this.separador +
                  grupo.cod +
                  this.separador +
                  campoCod +
                  this.separador2 +
                  campoCompuestoCod +
                  this.separador +
                  acabadoCod +
                  this.separador2 +
                  acabadoCompuestoCod;

                if (nImagenes > 1) {
                  // Generar y agregar las imágenes
                  for (let i = 0; i < nImagenes; i++) {
                    archivo =
                      baseArchivo +
                      this.separador +
                      (nImagenes === 1 ? "" : i + 1) +
                      "." +
                      this.extension;
                    imagenes.add({
                      orden: orden[campoCod + "_" + (i + 1)],
                      archivo: archivo,
                      img: Image,
                    });
                  }
                } else {
                  archivo = baseArchivo + "." + this.extension;
                  imagenes.add({
                    orden: orden[campoCod],
                    archivo: archivo,
                    img: Image,
                  });
                }
              } else {
                if (campo.acabadoSel.compuesto != undefined) {
                  // Transforma código (sólo existe el campo perfil con esta condición)
                  // Este sólo puede ser el campo "vidrio"
                  // 1.- Añade la capa TIPO_VIDRIO - PARED
                  campoCod = "TIPO_VIDRIO";
                  campoCompuestoCod = "PARED";
                  acabadoCod = campo.acabadoSel.cod;
                  acabadoCompuestoCod =
                    campo.acabadoSel.compuesto.acabadoSel.cod;
                  if (!isNaN(parseInt(acabadoCod))) {
                    acabadoCod = acabadoCod.padStart(2, "0");
                  }
                  if (!isNaN(parseInt(acabadoCompuestoCod))) {
                    acabadoCompuestoCod = acabadoCompuestoCod.padStart(2, "0");
                  }
                  if (acabadoCod == "00") {
                    // Incoloro 01
                    acabadoCod = "01";
                  } else {
                    // Decorado 04
                    acabadoCod = "04";
                  }

                  archivo =
                    coleccionCod +
                    prefijo +
                    this.separador +
                    grupo.cod +
                    this.separador +
                    campoCod +
                    this.separador2 +
                    campoCompuestoCod +
                    this.separador +
                    acabadoCod +
                    this.separador2 +
                    acabadoCompuestoCod +
                    "." +
                    this.extension;
                  imagenes.add({
                    orden: orden[campoCod],
                    archivo: archivo,
                    img: Image,
                  });
                  // 2.- Añade la capa DECORADO - COLOR_DECORADO
                  if (acabadoCod == "04") {
                    campoCod = "DECORADO";
                    campoCompuestoCod = "COLOR_DECORADO";
                    acabadoCod = campo.acabadoSel.cod;
                    if (!isNaN(parseInt(acabadoCod))) {
                      acabadoCod = acabadoCod.padStart(2, "0");
                    }

                    // Siempre es en color blanco...
                    acabadoCompuestoCod = "01";
                    // Excepto...
                    if (coleccionCod == "MINDANAO") {
                      if (acabadoCod == "38") {
                        acabadoCompuestoCod = "02";
                      }
                    }

                    archivo =
                      coleccionCod +
                      prefijo +
                      this.separador +
                      grupo.cod +
                      this.separador +
                      campoCod +
                      this.separador2 +
                      campoCompuestoCod +
                      this.separador +
                      acabadoCod +
                      this.separador2 +
                      acabadoCompuestoCod +
                      "." +
                      this.extension;
                    imagenes.add({
                      orden: orden[campoCod],
                      archivo: archivo,
                      img: Image,
                    });
                  }
                } else {
                  // Transforma código (sólo existe el campo perfil con esta condición)
                  if (campo.cod == "perfil") {
                    campoCod = "COLOR_PERFIL_ST";
                  } else {
                    campoCod = campo.cod;
                  }
                  acabadoCod = campo.acabadoSel.cod;
                  if (!isNaN(parseInt(acabadoCod))) {
                    acabadoCod = acabadoCod.padStart(2, "0");
                  }
                  archivo =
                    coleccionCod +
                    prefijo +
                    this.separador +
                    grupo.cod +
                    this.separador +
                    campoCod +
                    this.separador +
                    acabadoCod +
                    "." +
                    this.extension;
                  imagenes.add({
                    orden: orden[campoCod],
                    archivo: archivo,
                    img: Image,
                  });
                }
              }
            }
          }
        });
      });

      // Convertir a array
      imagenes = [...imagenes];

      imagenes = imagenes.sort(function (a, b) {
        return a.orden - b.orden;
      });
      //console.table(imagenes);

      var that = this;
      var imagenesPGN = [];
      Promise.all(
        imagenes.map((el) =>
          this.loadAsBlobImage(this.RequireImage(el.archivo)).then(
            (blobUrl) =>
              new Promise((resolve) => {
                const img = new Image();
                img.src = blobUrl;
                img.onload = () => {
                  el.img = img;
                  resolve(el);
                };
              })
          )
        )
      ).then((loadedImages) => {
        that.DibujaEscena(loadedImages, side);
      });
    },
    RequireImage(url) {
      var Image;
      // //console.log(
      //   "@/assets/Images/Colecciones/" +
      //     this.Version +
      //     "/" +
      //     this.aplicacion.coleccionSel.cod.toUpperCase() +
      //     "/" +
      //     url
      // );
      try {
        Image = require("@/assets/Images/Colecciones/" +
          this.Version +
          "/" +
          this.aplicacion.coleccionSel.codImage +
          "/" +
          url);
      } catch (error) {
        //Image = require("@/assets/Images/Colecciones/Error.webp");
        Image = require("@/assets/Images/Global/Transparente.webp");
        //console.log(error, url);
      }
      return Image;
    },
    DibujaEscena(imagenes, side) {
      //console.log(imagenes);
      imagenes.forEach((imagen) => {
        this.Context[side.cod].drawImage(
          imagen.img,
          0,
          0,
          this.Canvas[side.cod].width,
          this.Canvas[side.cod].height
        );
      });
      setTimeout(() => {
        this.Loading = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-transition: width 0.35s ease-in-out;
  -moz-transition: width 0.35s ease-in-out;
  -ms-transition: width 0.35s ease-in-out;
  -o-transition: width 0.35s ease-in-out;
  transition: width 0.35s ease-in-out;

  &__loader {
    opacity: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    height: 100px;
    -webkit-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
  }

  &__error {
    opacity: 0;
    background-color: rgb(0, 0, 0, 0.7);
    pointer-events: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 10000;
    -webkit-transition: opacity 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out;

    &__image {
      height: 100px;
      -webkit-transition: height 0.35s ease-in-out;
      -moz-transition: height 0.35s ease-in-out;
      -ms-transition: height 0.35s ease-in-out;
      -o-transition: height 0.35s ease-in-out;
      transition: height 0.35s ease-in-out;
    }

    &__textos {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-content: center;
      color: white;
      margin-top: 25px;

      &__item {
        &:not(:first-child) {
          margin-top: 5px;
        }
      }
    }
  }

  &__hotspot {
    opacity: 1;
    transform: scale(1);
    cursor: pointer;
    filter: invert(0%);
    position: absolute;
    z-index: 1000;
    height: 30px;
    -webkit-transition: all 0.35s ease-in-out;
    -moz-transition: all 0.35s ease-in-out;
    -ms-transition: all 0.35s ease-in-out;
    -o-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;

    &:not(.active):hover {
      opacity: 0.5;
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
    }

    &.active {
      opacity: 1;
      filter: invert(100%);
      animation: 0.5s activehotspot infinite alternate forwards;
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
    }

    @keyframes activehotspot {
      0% {
        transform: scale(1);
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
      }

      100% {
        transform: scale(1.15);
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
      }
    }

    &.hidden {
      opacity: 0 !important;
      top: 50% !important;
      left: 50% !important;
      pointer-events: none !important;
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
    }
  }

  &__comparator {
    opacity: 1;
    position: absolute;
    top: calc(50dvh - $Header-height);
    z-index: 1000;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    -webkit-transition: opacity 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out;

    &__side {
      cursor: pointer;
      width: 25px;
      height: 100%;
      filter: invert(100%);
      -webkit-transition: filter 0.35s ease-in-out;
      -moz-transition: filter 0.35s ease-in-out;
      -ms-transition: filter 0.35s ease-in-out;
      -o-transition: filter 0.35s ease-in-out;
      transition: filter 0.35s ease-in-out;

      &:first-child {
        transform: rotate(0deg);
      }

      &:last-child {
        transform: rotate(-180deg);
      }

      &.active {
        filter: invert(0%);
        -webkit-transition: filter 0.35s ease-in-out;
        -moz-transition: filter 0.35s ease-in-out;
        -ms-transition: filter 0.35s ease-in-out;
        -o-transition: filter 0.35s ease-in-out;
        transition: filter 0.35s ease-in-out;
      }

      &:not(.active):hover {
        filter: invert(80%);
        -webkit-transition: filter 0.35s ease-in-out;
        -moz-transition: filter 0.35s ease-in-out;
        -ms-transition: filter 0.35s ease-in-out;
        -o-transition: filter 0.35s ease-in-out;
        transition: filter 0.35s ease-in-out;
      }
    }

    &.hidden {
      opacity: 0;
      pointer-events: none;
      -webkit-transition: opacity 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out;
    }
  }

  &__slider {
    position: relative;
    transform: scale(1);
    filter: brightness(1);
    cursor: grab;
    width: 100%;
    height: 100%;
    min-height: calc(100dvh - $Header-height);
    max-height: calc(100dvh - $Header-height);
    outline: none;
    --default-handle-opacity: 0;
    --divider-color: black;
    --divider-width: 2px;
    background-repeat: no-repeat;
    background-position: center;
    -webkit-transition: filter 0.35s ease-in-out, transform 0.35s ease-in-out;
    -moz-transition: filter 0.35s ease-in-out, transform 0.35s ease-in-out;
    -ms-transition: filter 0.35s ease-in-out, transform 0.35s ease-in-out;
    -o-transition: filter 0.35s ease-in-out, transform 0.35s ease-in-out;
    transition: filter 0.35s ease-in-out, transform 0.35s ease-in-out;

    &__item {
      position: fixed;
      opacity: 1;
      width: 100%; // Salva
      height: 100%; // Salva
      min-height: calc(100dvh - $Header-height); // Salva
      max-height: calc(100dvh - $Header-height); // Salva
      object-fit: cover;
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
    }

    &.hidden {
      pointer-events: none;
    }

    &:active {
      cursor: grabbing;
    }
  }

  &.open {
    width: calc(100% - 350px);
    -webkit-transition: width 0.35s ease-in-out;
    -moz-transition: width 0.35s ease-in-out;
    -ms-transition: width 0.35s ease-in-out;
    -o-transition: width 0.35s ease-in-out;
    transition: width 0.35s ease-in-out;
  }

  &.error {
    & .canvas {
      &__error {
        opacity: 1;
        -webkit-transition: opacity 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out;
      }

      &__hotspot {
        opacity: 0 !important;
        top: 50% !important;
        left: 50% !important;
        pointer-events: none !important;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
      }
    }
  }

  &.loading {
    & .canvas {
      &__loader {
        opacity: 1;
        -webkit-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      }

      &__hotspot {
        opacity: 0 !important;
        top: 50% !important;
        left: 50% !important;
        pointer-events: none !important;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
      }

      &__slider {
        &__item {
          opacity: 0;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
        }
      }
    }
  }

  &.zoom {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }

  @media screen and (max-width: 950px) and (min-height: 600px) {
    width: 100% !important;
    height: calc(100dvh - 50px - 60px - 100px);
    -webkit-transition: height 0.35s ease-in-out;
    -moz-transition: height 0.35s ease-in-out;
    -ms-transition: height 0.35s ease-in-out;
    -o-transition: height 0.35s ease-in-out;
    transition: height 0.35s ease-in-out;

    &__comparator {
      top: calc((100% - 50px) / 2);

      &__side {
        width: 20px;
      }
    }

    &__hotspot {
      opacity: 0 !important;
      top: 50% !important;
      left: 50% !important;
      pointer-events: none !important;
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
    }

    &__slider {
      height: calc(100dvh - 50px - 60px - 100px);
      min-height: revert;
      max-height: revert;
      -webkit-transition: height 0.35s ease-in-out, filter 0.35s ease-in-out,
        transform 0.35s ease-in-out;
      -moz-transition: height 0.35s ease-in-out, filter 0.35s ease-in-out,
        transform 0.35s ease-in-out;
      -ms-transition: height 0.35s ease-in-out, filter 0.35s ease-in-out,
        transform 0.35s ease-in-out;
      -o-transition: height 0.35s ease-in-out, filter 0.35s ease-in-out,
        transform 0.35s ease-in-out;
      transition: height 0.35s ease-in-out, filter 0.35s ease-in-out,
        transform 0.35s ease-in-out;

      &__item {
        height: calc(100dvh - 50px - 60px - 100px);
        min-height: revert;
        max-height: revert;
        object-position: 67%;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
      }
    }

    &.open {
      height: calc(100dvh - (55dvh - 100px) - 50px - 80px - 100px);
      -webkit-transition: height 0.35s ease-in-out;
      -moz-transition: height 0.35s ease-in-out;
      -ms-transition: height 0.35s ease-in-out;
      -o-transition: height 0.35s ease-in-out;
      transition: height 0.35s ease-in-out;

      & .canvas {
        &__error {
          &__image {
            height: 70px;
            -webkit-transition: height 0.35s ease-in-out;
            -moz-transition: height 0.35s ease-in-out;
            -ms-transition: height 0.35s ease-in-out;
            -o-transition: height 0.35s ease-in-out;
            transition: height 0.35s ease-in-out;
          }
        }

        &__slider {
          height: calc(100dvh - (55dvh - 100px) - 50px - 80px - 100px);
          -webkit-transition: height 0.35s ease-in-out,
            object-position 0.35s ease-in-out, transform 0.35s ease-in-out;
          -moz-transition: height 0.35s ease-in-out,
            object-position 0.35s ease-in-out, transform 0.35s ease-in-out;
          -ms-transition: height 0.35s ease-in-out,
            object-position 0.35s ease-in-out, transform 0.35s ease-in-out;
          -o-transition: height 0.35s ease-in-out,
            object-position 0.35s ease-in-out, transform 0.35s ease-in-out;
          transition: height 0.35s ease-in-out,
            object-position 0.35s ease-in-out, transform 0.35s ease-in-out;

          &__item {
            height: calc(100dvh - (55dvh - 100px) - 50px - 80px - 100px);
            object-position: revert;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }
        }
      }
    }
  }

  @media screen and (max-height: 600px) {
    width: calc(100% - 100px);
    -webkit-transition: width 0.35s ease-in-out;
    -moz-transition: width 0.35s ease-in-out;
    -ms-transition: width 0.35s ease-in-out;
    -o-transition: width 0.35s ease-in-out;
    transition: width 0.35s ease-in-out;

    &__comparator {
      &__side {
        width: 20px;
      }
    }

    &__hotspot {
      opacity: 0 !important;
      top: 50% !important;
      left: 50% !important;
      pointer-events: none !important;
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
    }

    &.open {
      width: calc(100% - calc(40px + 247px));
      -webkit-transition: width 0.35s ease-in-out;
      -moz-transition: width 0.35s ease-in-out;
      -ms-transition: width 0.35s ease-in-out;
      -o-transition: width 0.35s ease-in-out;
      transition: width 0.35s ease-in-out;
    }
  }
}
</style>
